<template>
  <div class="container">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <div>
                <p>该栏目已下线</p>
                <p>请更新到最新版本</p>
            </div>
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.container_content{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    line-height: 2em;
    text-align: center;
}

</style>